
import Helper from './global/helper';
import Modal from './global/modal'  
import Tracking from './global/tracking'  
   
export default class Global { 
  static init() {
    Helper();
    Modal(); 
    Tracking(); 
  }  
}

